import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { PatientDetailScreen as ClinicalRecord } from '@parsina/framework/clinical';
import { useAppNavigate } from '../../hooks/useAppNavigate';

// /patients/:id/:tab? — the doctor panel's ROUTE onto the shared patient record.
//
// The record lives in @parsina/framework/clinical (docs/CLINICAL_KIT_DESIGN.md);
// this file owns the address bar and nothing else.
const PatientDetailScreen = () => {
  const navigate = useAppNavigate();
  const rrNavigate = useNavigate();
  const { id, tab } = useParams();
  const location = useLocation();
  const { state } = location;
  // URL param id is always authoritative; state may carry extra fields (name, etc.)
  // but its .id can be a different entity id (e.g. appointment id from calendar)
  const patient = { ...(state || {}), id };
  // The active section is a URL segment (/patients/:id/:tab), so refresh, back,
  // and shared links restore the same section. Switching tabs REPLACEs the entry:
  // the history stack keeps one entry per record, and goBack() below still returns
  // to the referrer, not to the previously open tab. location.state is re-sent so
  // the extra patient fields survive.
  const setTab = (item) => rrNavigate(
    `/patients/${id}${item && item !== 'overview' ? `/${item}` : ''}${location.search}`,
    { replace: true, state },
  );
  // Back affordance (§3.2): return to the actual referrer section — which
  // preserves its filters/scroll (context survives the round-trip). A deep link
  // has no in-app history (react-router marks the first entry key 'default'), so
  // we fall back to پذیرش rather than leaving the app.
  const goBack = () => {
    if (location.key && location.key !== 'default') rrNavigate(-1);
    else navigate('reception');
  };
  return <ClinicalRecord patient={patient} tab={tab} onTabChange={setTab} onBack={goBack} />;
};

export default PatientDetailScreen;
